<template>
    <div class="view bg-light">
        <simbar-header />
        <div class="view-title bg-white">
            <div class="container px-0">
                <h2>Configurações</h2>
            </div>
        </div>
        <main class="container view-container p-4 card shadow-sm my-3">
            <b-card no-body class="flex-fill">
                <b-tabs v-model="tabIndex" card>
                    <users-tab
                        v-if="canManageUsers || canViewLastLogins"
                        :permissions="generalPermissions"
                    />
                    <foz-chapeco-tab
                        v-if="fozChapecoPermissions.length > 0"
                        :permissions="fozChapecoPermissions"
                    />
                    <campos-novos-tab
                        v-if="camposNovosPermissions.length > 0"
                        :permissions="camposNovosPermissions"
                    />
                    <julho14-tab
                        v-if="julho14Permissions.length > 0"
                        :permissions="julho14Permissions"
                    />
                </b-tabs>
            </b-card>
        </main>
        <simbar-footer />
    </div>
</template>

<script>
import SimbarHeader from "@/modules/dashboard/components/SimbarHeader";
import SimbarFooter from "@/modules/dashboard/components/SimbarFooter";
import UsersTab from "@/modules/settings/components/UsersTab";
import FozChapecoTab from "@/modules/settings/components/foz_chapeco/FozChapecoTab";
import CamposNovosTab from "@/modules/settings/components/campos_novos/CamposNovosTab";
import Julho14Tab from "@/modules/settings/components/julho_14/Julho14Tab";

export default {
    name: "Settings",
    components: {
        SimbarHeader,
        SimbarFooter,
        UsersTab,
        FozChapecoTab,
        CamposNovosTab,
        Julho14Tab
    },
    data() {
        return {
            tabIndex: 0
        };
    },
    computed: {
        isSuperUser() {
            return this.$store.getters["auth/isSuperUser"];
        },
        fozChapecoPermissions() {
            return this.getPermissionsByDam("foz_chapeco");
        },
        camposNovosPermissions() {
            return this.getPermissionsByDam("campos_novos");
        },
        julho14Permissions() {
            return this.getPermissionsByDam("julho_14");
        },
        permissions() {
            if (this.$store.getters["auth/hasSpecialPermissions"]) {
                const {
                    user_permissions: permissions
                } = this.$store.state.auth.user;

                return permissions;
            }
            return [];
        },
        canViewLastLogins() {
            if (this.isSuperUser) {
                return true;
            }

            return this.permissions.includes("simbar.core.view_last_logins");
        },
        canManageUsers() {
            return this.isSuperUser;
        },
        generalPermissions() {
            const generalPermissions = [
                "simbar.core.manage_users",
                "simbar.core.view_last_logins"
            ];

            if (this.isSuperUser) {
                return generalPermissions;
            }

            return generalPermissions.filter(permission =>
                this.permissions.includes(permission)
            );
        }
    },
    methods: {
        getPermissionsByDam(dam) {
            if (this.isSuperUser) {
                return [`${dam}.all`];
            }

            return this.permissions.filter(permission =>
                permission.includes(`${dam}.`)
            );
        }
    }
};
</script>
